import React, { useState, useEffect } from "react";

export default function AdminLaporan({
  supabase,
  styles
}) {

  const [data, setData] = useState([]);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);

  const loadData = async () => {

    setLoading(true);

    const { data: hasil, error } = await supabase
      .from("laporan_warga")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      alert(error.message);
    } else {
      setData(hasil || []);
    }

    setLoading(false);

  };

  useEffect(() => {

    loadData();

  }, []);
  const simpanPerubahan = async (
    item,
    statusBaru,
    balasanBaru
  ) => {

    const { error } = await supabase
  .from("laporan_warga")
  .update({
    status: statusBaru,
    balasan_admin: balasanBaru,
    tanggal_update: new Date().toISOString(),
    diproses_oleh: "Admin RT"
  })
  .eq("id", item.id)
  .select();

console.log("HASIL UPDATE:", data);
console.log("ERROR UPDATE:", error);
  
      if (error) {
        console.log("ERROR LENGKAP:", error);
        alert(JSON.stringify(error, null, 2));
        return;
      }
  
    await loadData();
  
  };
  return (

    <div>

      <div
        style={{
          fontSize: "19px",
          fontWeight: "bold",
          color: "#1E5631",
          marginBottom: "14px"
        }}
      >
        Laporan Warga
      </div>

      {loading ? (

<div>Memuat data...</div>

) : data.length === 0 ? (

<div
  style={{
    background:"#fff",
    padding:"20px",
    borderRadius:"10px",
    textAlign:"center"
  }}
>
  Belum ada laporan dari warga.
</div>

) : (

<div>
  {data.map((item)=>(
    <div
      key={item.id}
      style={{
        background:"#fff",
        borderRadius:"12px",
        padding:"16px",
        marginBottom:"16px",
        boxShadow:"0 2px 8px rgba(0,0,0,0.05)"
      }}
    >

      <div><b>Rumah :</b> {item.nomor_rumah}</div>
      <div><b>Nama :</b> {item.nama_warga}</div>
      <div><b>Kategori :</b> {item.kategori}</div>
      <div><b>Judul :</b> {item.judul}</div>
      <div style={{marginTop:"8px"}}>
  <b>Deskripsi :</b>
</div>

<div
  style={{
    marginTop:"6px",
    marginBottom:"10px",
    whiteSpace:"pre-wrap"
  }}
>
  {item.deskripsi}
</div>

<div style={{marginBottom:"10px"}}>
  <b>Status :</b> {item.status}
</div>
<div style={{marginTop:"15px"}}>

  <div
    style={{
      fontWeight:"bold",
      marginBottom:"6px"
    }}
  >
    Ubah Status
  </div>

  <select
  value={editData[item.id]?.status ?? item.status}
  onChange={(e)=>
    setEditData(prev=>({
      ...prev,
      [item.id]:{
        ...prev[item.id],
        status:e.target.value
      }
    }))
  }
  style={styles.input}
>
    <option>Menunggu Jawaban</option>
    <option>Sedang Dikerjakan</option>
    <option>Selesai</option>
  </select>

</div>

<div style={{marginTop:"10px"}}>

  <div
    style={{
      fontWeight:"bold",
      marginBottom:"6px"
    }}
  >
    Balasan Pengurus
  </div>

  <textarea
  style={{
    ...styles.input,
    height:"100px"
  }}
  value={editData[item.id]?.balasan ?? item.balasan_admin ?? ""}
  onChange={(e)=>
    setEditData(prev=>({
      ...prev,
      [item.id]:{
        ...prev[item.id],
        balasan:e.target.value
      }
    }))
  }
  placeholder="Tulis balasan kepada warga..."
/>
</div>

<button
  style={styles.btnPrimary}
  onClick={() =>
    simpanPerubahan(
      item,
      editData[item.id]?.status ?? item.status,
      editData[item.id]?.balasan ?? item.balasan_admin ?? ""
    )
  }
>
  💾 Simpan Perubahan
</button>
{item.foto && (
  <a
    href={item.foto}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      color:"#1E5631",
      fontWeight:"bold",
      textDecoration:"none"
    }}
  >
    📷 Lihat Foto
  </a>
)}
    </div>
  ))}
</div>

)}

    </div>

  );

}